/** Мутация сохранения данных чертежа проекта. */
import { useMutation } from "@tanstack/react-query";
import { Api, type SaveProjectDataRequest } from "@/api";
import { projectsKeys } from "./keys";

type ProjectPath = { id: string };
type SaveProjectDataArgs = [path: ProjectPath, data: SaveProjectDataRequest];

export const useSaveProjectData = () => {
	const mutation = useMutation({
		mutationFn: ([path, data]: SaveProjectDataArgs) =>
			Api.Project.putApiProjectsDataById(path, data),
		mutationKey: projectsKeys.saveData,
		networkMode: "always",
	});

	return {
		execute: mutation.mutateAsync,
		isPending: mutation.isPending,
	};
};
